module.exports = __webpack_public_path__ + "static/media/wor_clo_to_wat_haz_lev.981d2bf4.png";